(function () {
    'use strict';

    angular
        .module("skillsApp")
        .directive("clusterTypeSelect", clusterTypeSelect);

    function clusterTypeSelect() {
        return {
            templateUrl: '/app/directives/cluster-type-select.tpl.html',
            scope: {
                'cluster': '=',
                'editMode': '='
            },
            controller: ClusterTypeSelectController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function ClusterTypeSelectController($translate, $q, logger, dataService, modalDialogService) {
        var vm = this;
        var allClusters = null;

        vm.addCluster = addCluster;
        vm.deleteCluster = deleteCluster;
        vm.editCluster = editCluster;
        vm.updateClusters = updateClusters;
        
        $q.all([dataService.getClusterTypes(), dataService.getAllClusters()]).then(results => {
            var clusterTypes = results[0];

            allClusters = results[1] || [];

            vm.clusterType = clusterTypes[0];
            vm.clusterTypes = clusterTypes;

            updateClusters();
        });

        function _afterClusterAddOrEdit(result) {
            if (result.clusterType !== vm.clusterType.type) {
                vm.clusterType = _.findWhere(vm.clusterTypes, { type: result.clusterType });
            }
            
            var existing = _.findWhere(allClusters, { id: result.id });
            if (existing) {
                existing.clusterType = result.clusterType;
                existing.name = result.name;
            } else {
                allClusters.push(result);
                vm.cluster = result;
            }
            
            vm.clusters = _.chain(allClusters)
                .filter(cluster => { return cluster.clusterType === vm.clusterType.type; })
                .sortBy(cluster => { return cluster.name.toLowerCase(); })
                .value();
        }

        function addCluster() {
            return modalDialogService.openEditClusterDialog({ clusterType: vm.clusterType.type }).then(result => { _afterClusterAddOrEdit(result); });
        }
        
        function deleteCluster() {
            var clusterId = vm.cluster.id;
            var title = 'delete_cluster';
            var message = 'confirm_delete_cluster';
            
            modalDialogService.confirmDelete(title, message, () => {
                dataService.deleteCluster(clusterId)
                    .then(() => {
                        logger.success('successfully_deleted');
                        allClusters.splice(allClusters.indexOf(vm.cluster), 1);
                        updateClusters();
                    });
            });
        }

        function editCluster() {
            return modalDialogService.openEditClusterDialog(vm.cluster).then(result => { _afterClusterAddOrEdit(result); });
        }

        function updateClusters() {
            var clusters = _.chain(allClusters)
                .filter((cluster) => { return cluster.clusterType === vm.clusterType.type; })
                .sortBy(cluster => { return cluster.name.toLowerCase(); })
                .value();

            vm.cluster = clusters[0];
            vm.clusters = clusters;
        }
    }
})();